// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__115pg","header":"PatientQuestionnaire_header__xuPCo","info":"PatientQuestionnaire_info__1xky8"};